package horcrux.common.utils

import arrow.core.raise.Raise

fun Raise<Throwable>.raiseError(msg: String): Nothing = raise(IllegalStateException(msg))
